import {useMutation} from '@tanstack/react-query';
import {getLocalStorage} from '@/Utils/CommonUtils';
import useChatRestClient from '@/Api/ChatRestClient';

export type ReferralRow = {
  name: string | null;
  masked_phone: string | null;
  status: 'signed_up' | 'converted' | 'rewarded';
  games_played: number;
  games_required: number;
  joined_at: string;
};

export type MyReferralsResponse = {
  success: boolean;
  games_required: number;
  referrals: ReferralRow[];
  page: number;
  page_size: number;
  total: number;
};

export default function useGetMyReferralsApi(
  handleOnSuccess?: (data: MyReferralsResponse) => void,
  handleOnError?: (data: any) => void,
) {
  const ChatRestClient = useChatRestClient();
  const mutation = useMutation<MyReferralsResponse, Error, {page?: number} | void>(
    async params => {
      const token = await getLocalStorage('access_token');
      const response = await ChatRestClient.get('auth/v1/referral/my_referrals', {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
        params: {page: params?.page || 1},
      });
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) handleOnSuccess(data);
      },
      onError: error => {
        if (handleOnError) handleOnError(error);
      },
    },
  );

  return {
    ...mutation,
  };
}
